import {
  AdvertiserEdit,
  AdvertiserEditRest,
  AdvertiserEntity,
  AdvertiserEntityFilter,
  AdvertiserEntityFilterRest,
  AdvertiserEntityRest,
  PaginationRequest,
  SortingRequest,
} from '@rp/shared/models';
import { ObjectUtils } from '@rp/utils';

import { PaginationAdapter } from './pagination.adapter';
import { SortingAdapter } from './sorting.adapter';

const fromRest = (advertiserEntityRest: AdvertiserEntityRest): AdvertiserEntity => {
  return {
    id: advertiserEntityRest.id,
    companyName: advertiserEntityRest.companyName,
    email: advertiserEntityRest.email,
    geos: advertiserEntityRest.geos,
    manager: advertiserEntityRest.manager,
    verticals: advertiserEntityRest.verticals.map(vertical => vertical.name).join(', '),
  };
};

const toRest = (
  filter: AdvertiserEntityFilter,
  pagination: PaginationRequest,
  sorting: SortingRequest,
): AdvertiserEntityFilterRest => ({
  ...PaginationAdapter.toRest(pagination),
  ...ObjectUtils.stripEmptyFields<Omit<AdvertiserEntityFilterRest, 'limit' | 'page'>>(
    {
      id: filter?.id,
      email: filter?.email,
      companyName: filter?.companyName,
      verticals: filter?.verticals,
      managerIds: filter?.managerIds,
      ...SortingAdapter.toRest(sorting),
    },
    true,
  ),
});

const fromEditRest = (rest: AdvertiserEditRest): AdvertiserEdit => {
  return {
    id: rest.id,
    companyName: rest.companyName,
    email: rest.email,
    website: rest.website,
    geos: rest.geos,
    verticals: rest.verticals?.map(vertical => vertical.id),
    managerId: rest.manager.id,
    contactPersonName: rest.contactPersonName,
    messengers: rest.messengers,
  };
};

const fromEdit = (advertiser: AdvertiserEdit): Partial<AdvertiserEntity> => ({
  id: advertiser.id,
  companyName: advertiser.companyName,
  email: advertiser.email,
});

export const AdvertiserEntityAdapter = {
  fromRest,
  toRest,
  fromEditRest,
  fromEdit,
};
